import { createRouter, createWebHashHistory } from "vue-router";
import store from "@/store";
import Cookies from 'js-cookie';
// 静态路由：登录页、Home 布局壳、首页面板，以及不在 getRouters 菜单树中的页面
// （详情页 / 历史入口）。菜单内的业务页面改由 getRouters 返回的数据动态注册，
// 见下方 registerDynamicRoutes。
const routes = [
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "record" */ "../views/About.vue"),
  },
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "record" */ "../views/Home.vue"),
    children: [
      {
        path: "/",
        component: () =>
          import(/* webpackChunkName: "record" */ "../views/index.vue"),
      },
      // 详情页：由 location 页内部跳转，不在菜单树中，保留静态
      {
        path: "/home/locationDetail",
        component: () =>
          import(
            /* webpackChunkName: "record" */ "../views/record/locationDetail.vue"
          ),
      },
      // 车辆查询：由 parkQuery 权限单独控制，可能不在菜单树中，保留静态
      {
        path: "/home/vehicleInfo",
        component: () =>
          import(
            /* webpackChunkName: "record" */ "../views/record/vehicleInfo.vue"
          ),
      },
      // 历史入口：未在菜单树中，暂保留静态以兼容旧链接
      {
        path: "/home/record",
        name: "record",
        component: () =>
          import(
            /* webpackChunkName: "record" */ "../views/record/gothrough.vue"
          ),
      },
      {
        path: "/home/moreCarRecord",
        name: "moreCarRecord",
        component: () =>
          import(
            /* webpackChunkName: "record" */ "../views/record/moreCarRecord.vue"
          ),
      },
      {
        path: "/home/videoRecord",
        name: "videoRecord",
        component: () =>
          import(
            /* webpackChunkName: "record" */ "../views/record/videoRecord.vue"
          ),
      },
    ],
  },
  {
    path: "/login",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

// 将 getRouters 返回的菜单组件字符串（如 "record/nowRecord.vue"）解析为按需加载组件。
// webpackInclude 限定动态 import 上下文只匹配 .vue 文件，避免把 @/views 下的
// 非组件文件（如 workspace.code-workspace）也打包进来导致编译失败。
const loadView = (view) => {
  const path = String(view || "").replace(/^\/+/, "");
  return () => import(/* webpackInclude: /\.vue$/ */ `@/views/${path}`);
};

// 把后端菜单树拍平为 Home 下的子路由：
// 跳过 Layout / ParentView 等容器节点，仅为带真实组件的叶子节点生成 /home/<path> 路由。
const buildDynamicRoutes = (nodes, result = []) => {
  (nodes || []).forEach((node) => {
    if (!node) return;
    const comp = node.component;
    if (comp && comp !== "Layout" && comp !== "ParentView") {
      result.push({
        path: "/home/" + node.path,
        component: loadView(comp),
      });
    }
    if (node.children && node.children.length) {
      buildDynamicRoutes(node.children, result);
    }
  });
  return result;
};

let dynamicRoutesReady = false;
let dynamicRouteRemovers = [];

// 清除已注册的动态路由（退回登录页时调用，便于重新登录后按最新权限重建）
const resetDynamicRoutes = () => {
  dynamicRouteRemovers.forEach((remove) => remove && remove());
  dynamicRouteRemovers = [];
  dynamicRoutesReady = false;
};

// 注册动态路由：已存在的路径（如保留的静态页）跳过，避免重复
const registerDynamicRoutes = (routers) => {
  resetDynamicRoutes();
  const existing = new Set(router.getRoutes().map((r) => r.path));
  buildDynamicRoutes(routers).forEach((route) => {
    if (!existing.has(route.path)) {
      dynamicRouteRemovers.push(router.addRoute("Home", route));
    }
  });
  dynamicRoutesReady = true;
};

//添加路由守卫
router.beforeEach(async (to) => {
  if (to.path === "/about") {
    resetDynamicRoutes();
    return true;
  }
  if (!Cookies.get("token")) {
    return "/about";
  }
  // 首次进入鉴权页面：拉取菜单并动态注册路由，注册后重新解析当前导航
  if (!dynamicRoutesReady) {
    const [routers] = await Promise.all([
      store.dispatch("getRouters"),
      store.dispatch("getInfo"),
    ]);
    registerDynamicRoutes(routers);
    return { path: to.path, query: to.query, hash: to.hash, replace: true };
  }
  return true;
});
export default router;
